export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11230.a9ee05b2.jpg";